import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import HeroSection from '../components/Home/HeroSection';
import ClientsSection from '../components/Home/ClientsSection';
import ContactPreview from '../components/Home/ContactPreview';

const Home: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Mirchi Republic Media Production - Creativity that Captivates</title>
        <meta name="description" content="Mirchi Republic Media Production - Creativity that Captivates. Execution that Endures. From Goa to the Globe. Expert event management, audio-visual production, and advertising services." />
        <meta property="og:title" content="Mirchi Republic Media Production - Creativity that Captivates" />
        <meta property="og:description" content="Mirchi Republic Media Production - Creativity that Captivates. Execution that Endures. From Goa to the Globe. Expert event management, audio-visual production, and advertising services." />
        <meta property="og:image" content="https://mirchirepublic.com/company-logo.jpg" />
        <meta property="og:url" content="https://mirchirepublic.com/" />
      </Helmet>
      
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <HeroSection />
        <ClientsSection />
        <ContactPreview />
      </motion.div>
    </>
  );
};

export default Home;